"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./BlockListItems.scss");
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _IconMiniBlock = _interopRequireDefault(require("../IconMiniBlock/IconMiniBlock"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const IconMiniBlocks = _ref => {
  let {
    content,
    motion
  } = _ref;
  const renderIconMiniBlocks = () => {
    if (content.blocks && content.blocks.length) {
      return content.blocks.map((block, index) => {
        const blockContent = {
          header: block?.header,
          link: block?.link,
          text: block?.text,
          type: block?.icon,
          backgroundColor: block?.backgroundColor,
          color: block?.color,
          alignment: content?.alignment,
          largeBlock: content?.largeBlock,
          Link: content?.Link
        };
        if (blockContent?.link) {
          blockContent.link.external = (0, _checkForExternalLink.default)(blockContent?.link?.url);
        }
        return /*#__PURE__*/_react.default.createElement(_IconMiniBlock.default, {
          key: index,
          content: blockContent,
          largeBlock: blockContent.largeBlock,
          alignment: blockContent.alignment,
          motion: motion ? motion : null,
          contentfulId: block?.contentfulId ? block?.contentfulId : null
        });
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-icon-mini-blocks ${content.largeBlock ? "ter-icon-mini-blocks--large" : ""}`
  }, renderIconMiniBlocks());
};
var _default = IconMiniBlocks;
exports.default = _default;